import { useWishList } from "@agent/context/wish-list";
import { Button } from "@presentation/shared/components/button/Button";
import { useEffect, useState } from "react";
import * as React from "react";
import TextInput from "@presentation/shared/components/text-input/TextInput";
import { FullPageLoader } from "@presentation/shared/components/loader/FullPageLoader";
import { ModalBody, ModalFooter, ModalHeader } from "flowbite-react";
import { T } from "@config/lang";
import { WishListItems } from "@agent/components/wish-list/WishListItems";

type Props = {
  onClose(): void;
};

export function WishList({ onClose }: Props) {
  const { wishList, loading, sendByEmail, removeFromWishList } = useWishList();

  const [email, setEmail] = useState("");
  const [removeAfterSending, setRemoveAfterSending] = useState(true);
  const [selected, setSelected] = useState<string[]>(() =>
    wishList.map((item) => item.hash)
  );

  useEffect(() => {
    setSelected((current) =>
      current.filter((hash) => wishList.find((it) => it.hash === hash))
    );
  }, [wishList]);

  const send = () => {
    const items = wishList.filter((item) => selected.includes(item.hash));
    sendByEmail(email, items, removeAfterSending);
    onClose();
    // Check errors
  };

  const toggleSelected = (hash: string) => {
    setSelected((current) => {
      if (current.includes(hash)) {
        return current.filter((it) => it !== hash);
      }
      return [...current, hash];
    });
  };

  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValid = selected.length > 0 && isValidEmail;

  const sections = {
    charter: { name: T.search_type_charter, items: [] },
    hotel: { name: T.search_type_hotel, items: [] },
  };

  for (const item of wishList) {
    sections[item.searchType].items.push(item);
  }

  return (
    <>
      <ModalHeader>
        Wish List{" "}
        <small className="text-gray-500 pl-6">
          {selected.length} out of {wishList.length} selected
        </small>
      </ModalHeader>
      <ModalBody>
        {loading && <FullPageLoader />}

        <table width="100%" cellPadding="0" cellSpacing="0">
          {Object.values(sections)
            .filter((it) => it.items.length)
            .map(({ name, items }) => (
              <>
                <tbody>
                  <tr>
                    <td
                      colSpan={3}
                      className="text-xl font-bold text-gray-500 text-center"
                    >
                      {name}
                    </td>
                  </tr>
                </tbody>
                <WishListItems
                  items={items}
                  selected={selected}
                  toggleSelected={toggleSelected}
                  removeFromWishList={removeFromWishList}
                />
              </>
            ))}
        </table>
      </ModalBody>
      <ModalFooter>
        <div className="flex gap-2 items-center">
          <span>Send to:</span>
          <TextInput
            className="w-96"
            value={email}
            onChange={setEmail}
            placeholder="Email"
          />
        </div>
        <Button type="primary" disabled={!isValid} onClick={send}>
          Send by email
        </Button>
        <div className="flex gap-2 items-center">
          <input
            type="checkbox"
            checked={removeAfterSending}
            onChange={() => setRemoveAfterSending((b) => !b)}
          />
          <span className="text-gray-600">Delete after sending</span>
        </div>
      </ModalFooter>
    </>
  );
}
